import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { MenuConfig } from '../models/menu-config';

@Injectable()
export class MenuConfigService {
  public configModel: MenuConfig = new MenuConfig();
  public onMenuUpdated$: BehaviorSubject<MenuConfig> = new BehaviorSubject(
    this.configModel,
  );
  menuHasChanged: any = false;

  setModel(menuModel: any): void {
    this.configModel = Object.assign(this.configModel, menuModel);
    this.onMenuUpdated$.next(this.configModel);
    this.menuHasChanged = true;
  }
}
